import React, { FC } from 'react'

import { IconArrowRightProps } from './IconArrowRight.types'
import * as Styled from './styles/IconArrowRight.style'

import { nonThemeableRules } from '../../ruleSet'

const IconArrowRight: FC<IconArrowRightProps> = ({
  size = nonThemeableRules.defaultSize as number as IconArrowRightProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconArrowRightProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M159.69 81.53a4 4 0 0 0 .13-.41c0-.11.08-.22.1-.34A4 4 0 0 0 160 80a4 4 0 0 0-.08-.78c0-.12-.07-.23-.1-.34a2.34 2.34 0 0 0-.33-.79c-.06-.1-.1-.21-.17-.31a4 4 0 0 0-.5-.61l-68-68a4 4 0 0 0-5.66 5.66L146.34 76H4a4 4 0 0 0 0 8h142.34l-61.17 61.17a4 4 0 1 0 5.66 5.66l68-68a4 4 0 0 0 .5-.61c.06-.1.11-.2.16-.3a3.94 3.94 0 0 0 .2-.39z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconArrowRight
